<template>
    <div class="searchNoBox">
        <div class="searchNo_t">
            <img :src="require('../../assets/images/u307.svg')" alt="">
            <div class="searchNo_title">暂无数据</div>
        </div>
        <!-- <div class="searchNo_b">
            <div class="searchNo_title">您还可以尝试以下搜索</div>
            <el-link type="danger" v-for="(v, i) of list" :key="i">{{v}}</el-link>
        </div> -->
    </div>
</template>

<script>
export default {
    data () {
        return {
            list: ['轨道','交通','XX','XXX','XXX','XXX','XXX','XXX'],
            text: this.$route.query.searchText
        }
    }
}
</script>

<style>
    .searchNoBox {
        width: 100%;
        /* height: 5rem; */
        height: 100%;
        margin: 0.3rem 0;
        border: 0.01rem solid #CCCCCC;
        padding: 1rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        font-size: 0.16rem;
    }
    .searchNo_t {
        width: 100%;
        height: 1.8rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
    }
    .searchNo_t > img {
        width: 10%;
    }
    .searchNo_title span {
        color: #228457;
        margin: 0 0.1rem;
    }
    .searchNo_b {
        height: 0.6rem;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
    }
    .searchNo_b .searchNo_title {
        width: 100%;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/ivew/searchNo.vue